import { addBreadcrumb } from './sentry';

/**
 * Lab-specific breadcrumb helpers for Sentry.
 * Call these at key interaction points to build a richer error trail.
 */

export function labLoaded() {
  addBreadcrumb('lab', 'Lab loaded', {
    url: window.location.href,
  });
}

export function circuitSaved(circuitId, title) {
  addBreadcrumb('lab', 'Circuit saved', {
    circuitId: circuitId,
    title: title,
  });
}

export function simulationRun(analysisMode) {
  addBreadcrumb('simulation', 'Simulation run', {
    analysisMode: analysisMode,
  });
}

export function componentAdded(componentType) {
  addBreadcrumb('lab', 'Component added', {
    componentType: componentType,
  });
}

export function aiChatMessage(messageType) {
  addBreadcrumb('ai', 'AI chat interaction', {
    messageType: messageType,
  });
}

export function canvasError(errorType, details) {
  addBreadcrumb('canvas', 'Canvas error detected by guard', {
    errorType: errorType,
    details: details,
  });
}
